import React from 'react';

const Metrics = ({ theme }) => {
    return (
        <div className="max-w-7xl mx-auto px-6">
            <div className={`grid grid-cols-1 md:grid-cols-3 gap-24 items-start py-20 border-b transition-colors duration-500 ${theme === 'dark' ? 'border-zinc-900' : 'border-zinc-200'}`}>
                <div className="flex flex-col gap-4">
                    <h2 className={`text-7xl font-bold tracking-tighter transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>98%</h2>
                    <p className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Automation Rate</p>
                    <p className="text-zinc-500 text-sm leading-relaxed">Most guests find exactly what they need instantly, without staff intervention.</p>
                </div>
                <div className="flex flex-col gap-4">
                    <h2 className={`text-7xl font-bold tracking-tighter transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>14d</h2>
                    <p className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Staff Time Recovered</p>
                    <p className="text-zinc-500 text-sm leading-relaxed">On average, properties recover two full weeks of operational time per year.</p>
                </div>
                <div className="flex flex-col gap-4">
                    <h2 className={`text-7xl font-bold tracking-tighter transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>&lt; 1s</h2>
                    <p className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Response Latency</p>
                    <p className="text-zinc-500 text-sm leading-relaxed">Unrivaled speed that creates a premium feeling of efficiency for your guests.</p>
                </div>
            </div>

            <div className="mt-40 grid grid-cols-1 lg:grid-cols-2 gap-32 items-center">
                <div>
                    <h3 className={`text-5xl font-bold mb-10 tracking-tighter leading-none transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Designed for <br /> hospitality-first teams.</h3>
                    <p className="text-xl text-zinc-500 leading-relaxed mb-12">
                        We don't replace people. We remove the noise. Kypser handles the data so your
                        concierges can handle the moments that require empathy, creativity, and real connection.
                    </p>
                    <div className="grid grid-cols-2 gap-8">
                        <div>
                            <h4 className={`font-bold mb-2 transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Multi-Property</h4>
                            <p className="text-sm text-zinc-500">Centralized control for entire portfolios.</p>
                        </div>
                        <div>
                            <h4 className={`font-bold mb-2 transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Operational Clarity</h4>
                            <p className="text-sm text-zinc-500">Clear, reliable guest communication.</p>
                        </div>
                    </div>
                </div>
                <div className="relative">
                    <div className={`aspect-square rounded-3xl flex items-center justify-center p-20 shadow-2xl border transition-all duration-500 ${theme === 'dark' ? 'bg-zinc-900 border-zinc-800 shadow-white/5' : 'bg-zinc-50 border-zinc-200 shadow-black/5'}`}>
                        <div className="text-center">
                            <div className={`text-[12rem] font-black absolute -bottom-20 -right-20 transition-colors ${theme === 'dark' ? 'text-white/20' : 'text-black/20'}`}>K</div>
                            <div className={`w-24 h-24 border-4 rounded-full flex items-center justify-center mb-8 transition-colors ${theme === 'dark' ? 'border-white/10' : 'border-black/5'}`}>
                                <div className={`w-12 h-12 rounded-full transition-colors ${theme === 'dark' ? 'bg-white' : 'bg-black'}`}></div>
                            </div>
                            <p className="text-zinc-500 font-mono text-xs tracking-widest uppercase">The Operational Protocol</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Metrics;
